export default {
  "b2b.smlouva-vytvoreni.title.vytvoreni": "Nová smlouva",
  "b2b.smlouva-vytvoreni.title.edit": "Editace smlouvy",
  "b2b.smlouva-vytvoreni.field.cislo.label": "Číslo smlouvy",
  "b2b.smlouva-vytvoreni.field.popis.label": "Popis",
  "b2b.smlouva-vytvoreni.field.fixMo.label": "Fixní nároky na MZO",
  "b2b.smlouva-vytvoreni.field.fixVo.label": "Fixní nároky na VZO",
  "b2b.smlouva-vytvoreni.field.platnostOd.label": "Platnost od",
  "b2b.smlouva-vytvoreni.field.platnostDo.label": "Platnost do",
  "b2b.smlouva-vytvoreni.button.submit-vytvoreni": "Založit",
  "b2b.smlouva-vytvoreni.button.submit-edit": "Uložit",
  "b2b.smlouva-vytvoreni.button.cancel": "Zrušit",
  "b2b.smlouva-vytvoreni.save-dialog.title": "Uložení smlouvy"
};
